/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { TagReferenceExerciseDto } from './tag-reference-exercise-dto';
 /**
 *
 *
 * @export
 * @interface TagReferencesDto
 */
export interface TagReferencesDto {

    /**
     * How many exercises carry this tag
     *
     * @type {number}
     * @memberof TagReferencesDto
     * @example 12
     */
    exercises: number;

    /**
     * The exercises carrying it, soft-deleted ones included — restoring one would bring the tag back with it.
     *
     * @type {Array<TagReferenceExerciseDto>}
     * @memberof TagReferencesDto
     */
    items: Array<TagReferenceExerciseDto>;
}
